import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { useParams } from '../../utilities/url'
import { withRouter, Link } from 'react-router-dom'
import { PagesPaths } from '../../constants/Pages'
import config from '../../config'
import { ResetPassword } from '../../components/authentication/ResetPassword'
import { getErrorTranslation } from '../../utilities/errors'
import { stores } from '../../stores'

class ResetPasswordPageComponent extends Component {
  constructor () {
    super()
    this.state = { error: '', loading: false, success: false }
  }

  redirect () {
    const { history } = this.props
    history.replace(PagesPaths.SIGNIN.path)
  }

  get params () {
    const { location } = this.props
    const params = useParams(location.search)
    const key = params.key
    const role = '' + (params.role ? params.role.toLowerCase() + 's' : '')
    return { key, role }
  }

  async componentDidMount () {
    const { key, role } = this.params
    if (!key || !role) {
      return this.redirect()
    }
    if ([ config.customers, config.professionals ].indexOf(role) === -1) {
      return this.redirect()
    }
  }

  async submit (password) {
    const { t, history } = this.props
    const params = this.params
    this.setState({ loading: true })
    try {
      await stores.authentication.resetPassword({ ...params, password })
    } catch (e) {
      this.setState({ error: getErrorTranslation(t, e), loading: false })
      return
    }
    // If user is connected - retrieve account
    if (stores.authentication.isAuthententicated()) {
      await stores.account.getAccount()
      history.replace(PagesPaths.ACCOUNT.path)
      return
    }
    this.setState({ success: true, error: false, loading: false })
  }

  render () {
    const { t } = this.props
    return (
      <div className='layout__container home__container--padding'>
        <div className='signin__container centered--container'>
          <div className='signin__title'>
            <h1>{t('common:account:reset_password')}</h1>
          </div>
          {/* Display form */}
          {
            !this.state.error && !this.state.success
            ? <div>
              <p>{t('common:account:reset_password_title')}</p>
              <ResetPassword onSubmit={(password) => this.submit(password)} loading={this.state.loading} />
            </div>
            : ''
          }
          {/* Display an error on failure (mostly because expired) */}
          {
            this.state.error && !this.state.success
            ? <p className='form__errormessage' style={{ fontSize: '15px', marginTop: '10px' }}>
              { t('common:account:reset_password_failed') } <Link to={PagesPaths.SIGNIN.path}>{ t('common:account:reset_password_failed_link')}</Link>
            </p>
            : ''
          }
          {/* Success page in case it's a professional reset. */}
          {
            !this.state.error && this.state.success
            ? (
              <p className='form__message' style={{ fontSize: '15px', marginTop: '10px' }}>
                { t('common:account:reset_password_success')}<br />
                { t('common:account:reset_password_success_text')}
              </p>
            ) : ''
          }
        </div>
      </div>)
  }
}

ResetPasswordPageComponent.propTypes = {
  t: func,
  history: object,
  location: object
}

export const ResetPasswordPage = withRouter(translate()(ResetPasswordPageComponent))



// WEBPACK FOOTER //
// ./src/pages/authentification/ResetPasswordPage.js